const BAD_NETWORK_RATIO = 0.1;
const SESSION_INTERVAL = 5;

export const isBadNetworkSurvey = ({
  playSeconds,
  poorNetworkSeconds,
}: {
  playSeconds: number;
  poorNetworkSeconds: number;
}): boolean => {
  return (
    playSeconds > 0 && poorNetworkSeconds / playSeconds >= BAD_NETWORK_RATIO
  );
};

export const shouldShowSurvey = ({
  sessionsPlayed,
}: {
  sessionsPlayed: number;
}): boolean => {
  if (sessionsPlayed === 1) return true;
  return sessionsPlayed > 0 && sessionsPlayed % SESSION_INTERVAL === 0;
};

let pendingSurvey: string | null = null;

export const setPendingSurvey = (gameSessionId?: string) => {
  pendingSurvey = gameSessionId ?? "";
};

export const getPendingSurvey = () => pendingSurvey;

export const clearPendingSurvey = () => {
  pendingSurvey = null;
};
